// src/context/SchedulerContext.js
import React, { createContext, useState } from 'react';

// Create the Context object
export const SchedulerContext = createContext();

// Create a Provider component
export const SchedulerProvider = ({ children }) => {
  const [selectedScheduler, setSelectedScheduler] = useState(null);
  //console.log("HOo",selectedScheduler);

  return (
    <SchedulerContext.Provider value={{ selectedScheduler, setSelectedScheduler }}>
      {children}
    </SchedulerContext.Provider>
  );
};